import { useDrag } from '@use-gesture/react';
import { FunctionComponent, MutableRefObject, useRef } from 'react';
import { DraftConfiguration } from '@/types';
import { getDeltaFromState } from '@/components/draft/utils/getDeltaFromState';
import { useConfigurationsFrame } from './ConfigurationsFrame';
import { useMultiSelectContext } from './MultiSelectContext';
import { TransformChangedCallback } from './TransformChangedContext';

interface MultiSelectFrameProps {
  configurations: DraftConfiguration[];
  transformCallbacks: MutableRefObject<Set<TransformChangedCallback>>;
}

export const MultiSelectFrame: FunctionComponent<MultiSelectFrameProps> = ({
  configurations,
  transformCallbacks,
}) => {
  const { configurationIds, setTransformData } = useMultiSelectContext();
  const moveElementRef = useRef<SVGRectElement>(null);
  useDrag(
    (state) => {
      if (state.touches > 1) {
        return;
      }

      const transformDelta = getDeltaFromState(state, moveElementRef);
      setTransformData([transformDelta, state.first, state.last, state.dragging]);
    },
    { target: moveElementRef }
  );

  const configurationMap = new Map(
    configurations.map((configuration) => [configuration.cid, configuration])
  );
  const selectedConfigurations: DraftConfiguration[] = [];
  for (const selectedConfigurationId of configurationIds) {
    const selectedConfiguration = configurationMap.get(selectedConfigurationId);
    if (selectedConfiguration) {
      selectedConfigurations.push(selectedConfiguration);
    }
  }

  return useConfigurationsFrame(selectedConfigurations, transformCallbacks, {
    className: 'configurations-frame--multi-select',
    fill: 'transparent',
    ref: moveElementRef,
  });
};
